import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "../utils/analytics";

// Sends one page_view per page change, for the public marketing pages only
// (the allowlist lives in utils/analytics.js). A query string change on the
// same page sends nothing.
export default function PageViewTracker() {
  const { pathname, search } = useLocation();
  const searchRef = useRef(search);
  searchRef.current = search;
  useEffect(() => {
    // After the page set its title.
    const id = setTimeout(() => trackPageView({ pathname, search: searchRef.current }), 0);
    return () => clearTimeout(id);
  }, [pathname]);
  return null;
}
